import { useEffect, useState } from "react";
import axios from "axios";
import { setPreviewAccessCode } from "../Helper/siteLinks";

const apiBase = (process.env.REACT_APP_API_URL ?? "").replace(/\/+$/, "");

/** Current weekly preview access code + rotation info (mirrors PreviewAccessCodeResult on the API). */
export interface PreviewAccessCode {
	/** False when the admin has no PreviewAccessCode:Secret configured (local dev) : no code to show. */
	configured: boolean;
	code: string;
	weekKey: string;
	nextRotationUtc: string;
	daysUntilRotation: number;
}

/**
 * Fetches the current preview access code once and publishes it to siteLinks so every admin→preview
 * link carries it (editors are never stopped by the preview gate). Also returns the data for display
 * (dashboard card). Mounted app-wide via PreviewAccessCodeLoader so the injection is always active.
 */
export const usePreviewAccessCode = () => {
	const [data, setData] = useState<PreviewAccessCode | null>(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		let cancelled = false;
		axios
			.get<PreviewAccessCode>(`${apiBase}/api/preview-access/code`, { withCredentials: true })
			.then((r) => {
				if (cancelled) return;
				setData(r.data ?? null);
				setPreviewAccessCode(r.data?.configured ? r.data.code : null);
			})
			.catch(() => {
				if (!cancelled) setData(null);
			})
			.finally(() => {
				if (!cancelled) setLoading(false);
			});
		return () => {
			cancelled = true;
		};
	}, []);

	return { data, loading };
};
